// extracted by mini-css-extract-plugin
module.exports = {"mobileHeight":"screen and (max-height: 824px)","content":"TwilioStartHelper_content__3DBA5","header":"TwilioStartHelper_header__16LPU","svg":"TwilioStartHelper_svg__2vp51"};